import React, {createContext, SetStateAction, useCallback, useContext, useEffect, useState} from 'react';
import {DataGameStorage, dataStorage} from "../../utils/StorageService";
import {ILeader} from "../../settings/Leaderbord/Leaderbord";
import styled from "styled-components";
// @ts-ignore
import videoFile from "./../../assets/video_live_background.mp4";
import {useMedia} from "../ImageProvider";

interface IContext {
    yandexSdk: any;
    lb: any;
    player: any;
    setDataPlayer: (payload: string) => void;
    isDataInit: boolean;
    totalScoreDataLb: ILeader;
    totalScoreDataBombLb: ILeader;
    handleRequestLeaderBord: (player?: any) => void;
}

export const YsdkContext = createContext<IContext | null>(null);

interface IProps {
    children: React.ReactNode;
}

const LoaderRoot = styled.div`
    height: 100%;
    min-height: 100vh;
    display: flex;
    justify-content:center;
    align-items: center;
    //background-color: #263038;
    background-color: #55aaee;
    width: 100%;
`;

const BackgroundVideo = styled.video`
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: left;
    transform: translate(-50%, -50%);
    z-index: -1;
`;

export const YandexSdkProvider = ({children}: IProps) => {
    const isLoaded = useMedia();
    const [lb, setLb] = useState<any>(null);
    const [totalScoreDataLb, setTotalScoreDataLb] = useState<ILeader>({entries: []})
    const [totalScoreDataBombLb, setTotalScoreDataBombLb] = useState<ILeader>({entries: []})

    const [isDataInit, setDataInit] = useState(false);
    const [yandexSdk, setYandexSdk] = useState<any>(null);
    const [player, setPlayer] = useState<any>(undefined)

    useEffect(() => {
        YaGames
            .init()
            .then(ya => {
                // setTimeout(() => {
                    console.log('Yandex SDK initialized');
                    window.ysdk = ya;
                    ya.features.LoadingAPI?.ready(); // Показываем SDK, что игра загрузилась и можно начинать играть
                    setYandexSdk(ya)
                    ya.getLeaderboards()
                        .then((_lb: any) => {
                            setLb(_lb);
                        });
                // }, 5000)
            })
    }, [])

    const handleRequestLeaderBord = (_player?: any) => {
        yandexSdk.getLeaderboards()
            .then((lb: any) => {
                if (_player || player) {
                    lb.getLeaderboardEntries('totalScoreData', {
                        quantityTop: 20,
                        includeUser: true,
                        quantityAround: 3,
                    })
                    .then((res: SetStateAction<ILeader>) => setTotalScoreDataLb(res));
                } else {
                    lb.getLeaderboardEntries('totalScoreData')
                    .then((res: SetStateAction<ILeader>) => setTotalScoreDataLb(res));
                }
            })
        yandexSdk.getLeaderboards()
            .then((lb: any) => {
                if (_player || player) {
                    lb.getLeaderboardEntries('totalScoreBombData', {
                        quantityTop: 20,
                        includeUser: true,
                        quantityAround: 3,
                    })
                        .then((res: SetStateAction<ILeader>) => setTotalScoreDataBombLb(res));
                } else {
                    lb.getLeaderboardEntries('totalScoreBombData')
                        .then((res: SetStateAction<ILeader>) => setTotalScoreDataBombLb(res));
                }
            })
    }

    const initPlayer = useCallback(() => {
        return yandexSdk.getPlayer({scopes: true}).then((_player: any) => {
            if (_player._personalInfo.mode !== 'lite') {
                setPlayer(_player);
                return _player;
            }
            return null;
        })
    }, [player, yandexSdk]);

    const getDataPlayer = useCallback((_player?: any) => {
        if (_player) {
            _player.getData().then((data: DataGameStorage) => {
                console.log('data', data)
                setDataInit(true);

                if (data) {
                    dataStorage.setDataInitialize(data);
                }
            }).catch((e: any) => e);
            return
        }

        yandexSdk.getStorage().then((storage: any) => {
            const data: string = storage.getItem('data');
            setDataInit(true);
            if (data) {
                dataStorage.setDataInitialize(JSON.parse(data));
            }
        })
    }, [yandexSdk, player]);

    useEffect(() => {
        console.log('version: v2.1.15')
        if (!yandexSdk) return;
        initPlayer().then((_player: { getMode: () => string; }) => {
            getDataPlayer(_player);
            handleRequestLeaderBord(_player);
        }).catch((err: any) => {
            getDataPlayer();
            handleRequestLeaderBord();
            // Ошибка при инициализации объекта Player.
        });
    }, [initPlayer, yandexSdk, yandexSdk?.auth, getDataPlayer])

    const setDataPlayer = useCallback((payload: string) => {
        if (yandexSdk) {
            if (player) {
                player.setData(JSON.parse(payload)).then(() => {
                })

                return;
            }

            yandexSdk.getStorage().then((safeStorage: any) => {
                safeStorage.setItem('data', payload);
            })
        }
    }, [yandexSdk, player])

    return (
        <YsdkContext.Provider
            value={{
                yandexSdk,
                lb,
                player,
                totalScoreDataLb,
                totalScoreDataBombLb,
                isDataInit,
                setDataPlayer,
                handleRequestLeaderBord,
            }}>
            {(!yandexSdk || !isDataInit || !isLoaded) ? (
                <>
                    <LoaderRoot>
                        <span className="loader" />
                    </LoaderRoot>

                    <BackgroundVideo style={{opacity: 0, position: 'absolute', width: 0, height: 0}} autoPlay loop muted playsInline preload="auto">
                        <source src={videoFile} type="video/mp4"/>
                        Your browser does not support the video tag.
                    </BackgroundVideo>
                </>
            ) : children}
        </YsdkContext.Provider>
    );
};

export const useYandexSdk = () => {
    const context = useContext(YsdkContext);

    if (!context) {
        throw new Error('useYandexSdk should be use inside YsdkProvider');
    }

    return context;
};
